module.exports = __webpack_public_path__ + "static/media/13.92d389b4.jpg";